import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import SvgIcon from '../svg-icon/svg-icon';
import css from './index.scss';
import Button from '../../components/button/index';
import { Cross, Tick } from '../../helpers/icon-dictionary';
import messages from './messages';

const StudentUnassign = ({ icon, title, handleOnOk, handleOnCancel, isLoading, children, intl }) => (
    <div className={css.confirmationMessageContainer}>
        <div className={css.icon}>
            <SvgIcon icon={icon} />
        </div>
        <div className={css.title}>{title}</div>
        <div className={css.message} >
            {children}
            <div className={css.confirm}><span className={css.highlight}>{intl.formatMessage(messages.doYouWishToContinue)}</span></div>
        </div>
        <div className={css.container}>
            <Button
                buttonContainer={css.cancel}
                buttonContainerDisabled={css.cancelButtonDisabled}
                disabled={isLoading}
                handleOnClick={handleOnCancel}
                icon={Cross}
                iconClassName={css.iconClassName}
                loading={isLoading} />
            <Button
                buttonContainer={css.ok}
                buttonContainerDisabled={css.okButtonDisabled}
                disabled={isLoading}
                handleOnClick={handleOnOk}
                icon={Tick}
                iconClassName={css.iconClassName}
                loading={isLoading} />
        </div>
    </div>
);

StudentUnassign.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    handleOnOk: PropTypes.func,
    handleOnCancel: PropTypes.func,
    isLoading: PropTypes.bool,
    children: PropTypes.node,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(StudentUnassign));



// WEBPACK FOOTER //
// ./app/components/student-unassign/index.js